// extracted by mini-css-extract-plugin
export default {"space":"LoginForm_space__evOEO","forgotWrapper":"LoginForm_forgotWrapper__Ol5TK","forgotPassword":"LoginForm_forgotPassword__yhfX1"};